// /src/components/MenuItemContentTitle.js
import React from 'react';

const MenuItemContentTitle = ({ title }) => {
    return <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{title}</h3>;
};

export default MenuItemContentTitle;
